import { render, staticRenderFns } from "./PeriodoSelect.vue?vue&type=template&id=fddf3fe4"
import script from "./PeriodoSelect.vue?vue&type=script&lang=js"
export * from "./PeriodoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports